export const isLastNameFirst = (locale) => {
    return locale === 'ja' || locale === 'ko' || locale === 'zh';
};
//# sourceMappingURL=isLastNameFirst.js.map